import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../services/authService';

const RootRedirect = () => {
  const session = authService.checkExistingSession();

  // If user has valid session, redirect to their dashboard
  if (session.hasSession && session.dashboardPath) {
    console.log(
      `🔄 Root redirect: User authenticated, redirecting to ${session.dashboardPath}`
    );
    return <Navigate to={session.dashboardPath} replace />;
  }

  // Otherwise, redirect to login
  console.log('🔄 Root redirect: No session, redirecting to login');
  return <Navigate to="/auth/login" replace />;
};

export default RootRedirect;
